export const cardEmiLenders = [
  {
    bankCode: 'ICIC',
    name: 'ICICI Bank',
    logoIcon: 'https://iccdn.in/lenders/icici-icon-logo-v4.svg',
    category: 'EMI',
    useGenericIcon: false,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 12.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 13.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 13.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 14.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 14.99,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 1500,
  },
  {
    bankCode: 'HDFC',
    name: 'HDFC Bank',
    logoIcon: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
    category: 'EMI',
    useGenericIcon: false,

    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],
    minLoanAmount: 3000,
  },
  {
    bankCode: 'KKBK',
    name: 'Kotak Mahindra Bank',
    logoIcon: 'https://iccdn.in/img/kotak-icon-v1.png',
    category: 'EMI',
    useGenericIcon: false,

    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 12,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 12,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 3000,
  },
  {
    bankCode: 'BARB',
    name: 'Bank of Baroda',
    logoIcon: 'https://iccdn.in/lenders/bob-logo-sqr.svg',
    category: 'EMI',
    useGenericIcon: false,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,

        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2500,
  },
  {
    bankCode: 'AMEX',
    name: 'American Express',
    logoIcon: 'https://iccdn.in/extlenders/amex_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 5000,
  },
  {
    bankCode: 'CITI',
    name: 'Citibank',
    useGenericIcon: true,
    logoIcon: 'https://iccdn.in/extlenders/citi_logo.svg',
    category: 'EMI',
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2500,
  },
  {
    bankCode: 'HSBC',
    name: 'HSBC Bank',
    logoIcon: 'https://iccdn.in/extlenders/hsbc_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 12.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 12.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 13.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 13.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 13.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 13.5,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2000,
  },
  {
    bankCode: 'INDB',
    name: 'Induslnd Bank',
    logoIcon: 'https://iccdn.in/extlenders/indusind_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2000,
  },

  {
    bankCode: 'RATN',
    name: 'RBL Bank',
    logoIcon: 'https://iccdn.in/extlenders/rbl_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 1000,
  },
  {
    bankCode: 'SBIN',
    name: 'State Bank of India',
    logoIcon: 'https://iccdn.in/extlenders/sbi_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: null,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: null,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2500,
  },
  {
    bankCode: 'SCBL',
    name: 'Standard Chartered',
    logoIcon: 'https://iccdn.in/extlenders/sc_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 11.88,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 2500,
  },
  {
    bankCode: 'UTIB',
    name: 'Axis Bank',
    logoIcon: 'https://iccdn.in/extlenders/axis_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 3000,
  },

  {
    bankCode: 'YESB',
    name: 'Yes Bank',
    logoIcon: 'https://iccdn.in/extlenders/yes_logo.svg',
    category: 'EMI',
    useGenericIcon: true,
    emiPlans: [
      {
        emiPlanId: '1',
        tenure: 3,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '2',
        tenure: 6,
        interestRate: 13,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '3',
        tenure: 9,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '4',
        tenure: 12,
        interestRate: 14,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '5',
        tenure: 18,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
      {
        emiPlanId: '6',
        tenure: 24,
        interestRate: 15,
        currency: 'INR',
        emi: null,
        totalAmountPayableToBank: null,
      },
    ],

    minLoanAmount: 1500,
  },
];



// WEBPACK FOOTER //
// ./constants/cardEmiLenderInfo.js